import { Types } from '@amplitude/analytics-browser';
import { BeforePlugin, PluginType } from '@amplitude/analytics-types';

/**
 * This class is for iOS specifically. This won't be used on web or Android.
 */
export class IdfaPlugin implements BeforePlugin {
  name = 'idfa';
  type = PluginType.BEFORE as PluginType.BEFORE;
  idfa: string | null = null;

  async setup(_config: Types.Config): Promise<undefined> {}

  async execute(context: Types.Event): Promise<Types.Event> {
    return context;
  }
}
